import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyApplicationTypePage = {
  footer: {
    root: 'apply-application-type-page.footer.root',
  },
  form: {
    h1: 'apply-application-type-page.form.h1',
    h2: 'apply-application-type-page.form.h2',
    radioGroupRoot: 'apply-application-type-page.form.radio-group-root',
    radioOption1: 'apply-application-type-page.form.radio-option1',
    radioOption2: 'apply-application-type-page.form.radio-option2',
    radioOption3: 'apply-application-type-page.form.radio-option3',
    root: 'apply-application-type-page.form.root',
    submitButton: 'apply-application-type-page.form.submit-button',
  },
  header: {
    drawerButton: 'apply-application-type-page.header.drawer-button',
    previousStepButton:
      'apply-application-type-page.header.previous-step-button',
    root: 'apply-application-type-page.header.root',
  },
  progress: {
    root: 'apply-application-type-page.progress.root',
  },
} as const satisfies PageLocatorMap;
